import React, { useState } from 'react';
import { WhatsAppIcon, PhoneIcon, EmailIcon, XIcon, MessageIcon } from './Icons';

const InquiryWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const whatsappMessage = `Quick Inquiry%0A%0AName: ${formData.name}%0APhone: ${formData.phone}%0AMessage: ${formData.message}`;
    window.open(`https://wa.me/917718838808?text=${whatsappMessage}`, '_blank');
    setFormData({ name: '', phone: '', message: '' });
    setIsOpen(false);
  };

  const quickActions = [
    {
      label: 'Package Inquiry',
      action: () => {
        window.open('https://wa.me/917718838808?text=Hi, I want to know about travel packages', '_blank');
        setIsOpen(false);
      }
    },
    {
      label: 'Custom Package',
      action: () => {
        window.open('https://wa.me/917718838808?text=Hi, I need a custom travel package', '_blank');
        setIsOpen(false);
      }
    },
    {
      label: 'Call Now',
      action: () => {
        window.location.href = 'tel:+917718838808';
        setIsOpen(false);
      }
    }
  ];

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 bg-primary-orange text-white p-4 rounded-full shadow-2xl hover:bg-primary-blue transform hover:scale-110 transition-all duration-300 flex items-center justify-center group"
          aria-label="Open inquiry widget"
        >
          <MessageIcon className="w-6 h-6" />
        </button>
      )}

      {/* Widget Panel */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50 w-80 md:w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-slide-up">
          {/* Header */}
          <div className="bg-gradient-to-r from-primary-blue to-primary-orange text-white p-4 flex items-center justify-between">
            <div>
              <h3 className="font-bold text-lg">Happy Yatra Travels</h3>
              <p className="text-sm text-white/90">How can we help you?</p>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 transition-colors"
              aria-label="Close widget"
            >
              <XIcon className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-4 max-h-96 overflow-y-auto">
            {/* Quick Actions */}
            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-3 font-semibold">Quick Actions:</p>
              <div className="space-y-2">
                {quickActions.map((action, index) => (
                  <button
                    key={index}
                    onClick={action.action}
                    className="w-full text-left px-4 py-2 bg-gray-50 hover:bg-primary-blue hover:text-white rounded-lg transition-all duration-200 text-sm font-medium"
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <p className="text-sm text-gray-600 mb-3 font-semibold">Or send us a message:</p>
              
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-blue text-sm"
                  />
                </div>
                <div>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-blue text-sm"
                  />
                </div>
                <div>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your message..."
                    rows="3"
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-blue text-sm resize-none"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-primary-orange text-white py-2 rounded-lg font-semibold hover:bg-primary-blue transition-colors text-sm flex items-center justify-center gap-2"
                >
                  <WhatsAppIcon className="w-4 h-4" />
                  Send via WhatsApp
                </button>
              </form>
            </div>

            {/* Contact Options */}
            <div className="border-t border-gray-200 pt-4 mt-4">
              <p className="text-sm text-gray-600 mb-3 font-semibold">Contact us directly:</p>
              <div className="space-y-2">
                <a
                  href="https://wa.me/917718838808"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 px-3 py-2 bg-[#25d366] text-white rounded-lg hover:bg-[#20ba5a] transition-colors text-sm"
                >
                  <WhatsAppIcon className="w-4 h-4" />
                  WhatsApp
                </a>
                <a
                  href="tel:+917718838808"
                  className="flex items-center gap-2 px-3 py-2 bg-primary-blue text-white rounded-lg hover:bg-dark-blue transition-colors text-sm"
                >
                  <PhoneIcon className="w-4 h-4" />
                  Call Now
                </a>
                <a
                  href="mailto:info@happyyatratravels.in"
                  className="flex items-center gap-2 px-3 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors text-sm"
                >
                  <EmailIcon className="w-4 h-4" />
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InquiryWidget;
